module.exports = __webpack_public_path__ + "media/images/video-icon-45658459.svg";